import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../common/api";

// Async Thunks برای هر API
export const fetchNews = createAsyncThunk(
    "news/fetchNews",
    async ({ pageNumber, pageSize }, { rejectWithValue }) => {
        try {
            const response = await api.get(`/Home/news?pageNumber=${pageNumber}&pageSize=${pageSize}`);
            if (response.data.success) {
                return {
                    news: response.data.data.items,
                    totalPages: response.data.data.totalPages,
                };
            } else {
                return rejectWithValue(response.data.message || "خطایی رخ داده است");
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

// Async Thunk برای گرفتن جزئیات یک خبر بر اساس آیدی
export const fetchNewsDetails = createAsyncThunk(
    "news/fetchNewsDetails",
    async (newsId, { rejectWithValue }) => {
        try {
            const response = await api.get(`/Home/news/${newsId}`);
            if (response.data.success) {
                return response.data.data;
            } else {
                return rejectWithValue(response.data.message || "خطایی رخ داده است");
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const searchNews = createAsyncThunk(
    "news/searchNews",
    async ({ searchTerm, pageNumber, pageSize }, { rejectWithValue }) => {
        try {
            const response = await api.get(`/Home/searchNews?searchTerm=${searchTerm}&pageNumber=${pageNumber}&pageSize=${pageSize}`);
            if (response.data.success) {
                return {
                    searchResults: response.data.data.items,
                    totalPages: response.data.data.totalPages,
                };
            } else {
                return rejectWithValue(response.data.message || "خطایی رخ داده است");
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);


export const fetchNewsCategories = createAsyncThunk(
    "news/fetchCategories",
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get(`/Home/news/categories`);
            if (response.data.success) {
                return response.data.data;
            } else {
                return rejectWithValue(response.data.message || "خطایی رخ داده است");
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const fetchNewsByCategory = createAsyncThunk(
    "news/fetchNewsByCategory",
    async ({ categoryId, pageNumber, pageSize }, { rejectWithValue }) => {
        try {
            const response = await api.get(`/Home/news/category/${categoryId}?pageNumber=${pageNumber}&pageSize=${pageSize}`);
            if (response.data.success) {
                return {
                    news: response.data.data.items,
                    totalPages: response.data.data.totalPages,
                };
            } else {
                return rejectWithValue(response.data.message || "خطایی رخ داده است");
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);


export const fetchRecentNews = createAsyncThunk(
    "news/fetchRecentNews",
    async (count, { rejectWithValue }) => {
        try {
            const response = await api.get(`/Home/news/recent?count=${count}`);
            if (response.data.success) {
                return { recentNews: response.data.data };
            } else {
                return rejectWithValue(response.data.message || "خطایی رخ داده است");
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const fetchTopKeywords = createAsyncThunk(
    "news/fetchTopKeywords",
    async (topCount, { rejectWithValue }) => {
        try {
            const response = await api.get(`/Home/news/top-keywords?topCount=${topCount}`);
            if (response.data.success) {
                return { topKeywords: response.data.data };
            } else {
                return rejectWithValue(response.data.message || "خطایی رخ داده است");
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const searchNewsByKeyword = createAsyncThunk(
    "news/searchNewsByKeyword",
    async ({ keyword, pageNumber, pageSize }, { rejectWithValue }) => {
        try {
            const response = await api.get(`/Home/news/search?keyword=${keyword}&pageNumber=${pageNumber}&pageSize=${pageSize}`);
            if (response.data.success) {
                return {
                    keywordResults: response.data.data.items,
                    totalPages: response.data.data.totalPages,
                };
            } else {
                return rejectWithValue(response.data.message || "خطایی رخ داده است");
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);


const newsSlice = createSlice({
    name: "news",
    initialState: {
        news: [],
        newsDetails: null,
        categories: [],
        recentNews: [],
        topKeywords: [],
        totalPages: 0,
        currentPage: 1,
        status: "idle", // idle | loading | succeeded | failed
        error: null,
    },
    reducers: {
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchNews.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(fetchNews.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.news = action.payload.news;
                state.totalPages = action.payload.totalPages;
            })
            .addCase(fetchNews.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            })
            .addCase(fetchNewsDetails.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(fetchNewsDetails.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.newsDetails = action.payload;
            })
            .addCase(fetchNewsDetails.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            })
            .addCase(searchNews.pending, (state) => {
                console.log('searchNews loading')

                state.status = "loading";
                state.error = null;
            })
            .addCase(searchNews.fulfilled, (state, action) => {
                console.log('searchNews succeeded')

                state.status = "succeeded";
                state.news = action.payload.searchResults;
                state.totalPages = action.payload.totalPages;
            })
            .addCase(searchNews.rejected, (state, action) => {
                console.log('searchNews failed')

                state.status = "failed";
                state.error = action.payload;
            })
            .addCase(fetchNewsCategories.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(fetchNewsCategories.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.categories = action.payload;
            })
            .addCase(fetchNewsCategories.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            })
            .addCase(fetchNewsByCategory.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(fetchNewsByCategory.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.news = action.payload.news;
                state.totalPages = action.payload.totalPages;
            })
            .addCase(fetchNewsByCategory.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            })
            .addCase(fetchRecentNews.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(fetchRecentNews.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.recentNews = action.payload.recentNews;
            })
            .addCase(fetchRecentNews.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            })
            .addCase(fetchTopKeywords.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(fetchTopKeywords.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.topKeywords = action.payload.topKeywords;
            })
            .addCase(fetchTopKeywords.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            })
            .addCase(searchNewsByKeyword.pending, (state) => {
                console.log('searchNewsByKeyword loading')
                state.status = "loading";
                state.error = null;
            })
            .addCase(searchNewsByKeyword.fulfilled, (state, action) => {
                console.log('searchNewsByKeyword succeeded')

                state.status = "succeeded";
                state.news = action.payload.keywordResults;
                state.totalPages = action.payload.totalPages;
            })
            .addCase(searchNewsByKeyword.rejected, (state, action) => {
                console.log('searchNewsByKeyword failed')

                state.status = "failed";
                state.error = action.payload;
            });
    },
});

export const { setCurrentPage } = newsSlice.actions;
export default newsSlice.reducer;
